<kendo-tabstrip fxFlex="1 1 auto">
   <kendo-tabstrip-tab [selected]="!(settingsComponent$ | async)">
      <ng-template kendoTabTitle>
         <fa-icon class="sam-margin-right" [icon]="categoryIconCommon"></fa-icon>
         {{ 'brick.brick-management.settings.common' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-brick-common-settings [brickInstanceId]="brickInstanceId"></samweb-brick-common-settings>
      </ng-template>
   </kendo-tabstrip-tab>

   <kendo-tabstrip-tab [selected]="true" *ngIf="settingsComponent$ | async">
      <ng-template kendoTabTitle>
         <fa-icon class="sam-margin-right" [icon]="(brickDescription$ | async).definition.brickIcon"></fa-icon>
         {{ specificSettingsTabTitle$ | async }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-brick-specific-type-settings [brickInstanceId]="brickInstanceId"></samweb-brick-specific-type-settings>
      </ng-template>
   </kendo-tabstrip-tab>
</kendo-tabstrip>

<div fxLayout="row" fxFlexAlign="end" fxLayoutGap="5px" class="sam-margin">
   <button kendoButton [primary]="true" (click)="closeDialog()">
      <fa-icon class="sam-margin-right" [icon]="saveIcon"></fa-icon>
      <div class="sam-button-text">
         {{ 'brick.brick-management.settings.close' | translate }}
      </div>
   </button>
</div>
